import { useEffect } from 'react';

import { FakeLink } from '@change-corgi/design-system-legacy/components/actions';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { useSuggestedTemplateNotice } from './hooks/useSuggestedTemplateNotice';

type SuggestedTemplateNoticeProps = {
	onClick: () => void;
};

export function SuggestedTemplateNotice({ onClick }: SuggestedTemplateNoticeProps) {
	const {
		actions: { handleClick, trackSuggestedTemplateBannerView },
	} = useSuggestedTemplateNotice({ onClick });

	useEffect(() => {
		trackSuggestedTemplateBannerView();
	}, [trackSuggestedTemplateBannerView]);

	return (
		<div
			data-qa="update-supporters-suggested-template-notice"
			sx={{
				backgroundColor: 'primary-greyBackground',
				borderRadius: 8,
				marginTop: 32,
				padding: 16,
				display: 'flex',
				gap: 4,
				flexDirection: 'column',
				lineHeight: 20,
			}}
		>
			<Text fontWeight="bold">Need help writing your update?</Text>
			<Text fontWeight="normal">
				Energize your supporters with a message that highlights your current signature count and encourages them to
				spread the word.
			</Text>
			<FakeLink
				data-qa="update-supporters-suggested-template-notice-link"
				onClick={() => handleClick()}
				sx={{ width: 'fit-content' }}
			>
				Generate suggested draft
			</FakeLink>
		</div>
	);
}
